var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUbuntuDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 0H60C26.8629 0 0 26.8629 0 60V196C0 229.137 26.8629 256 60 256H196C229.137 256 256 229.137 256 196V60C256 26.8629 229.137 0 196 0Z",
    fill: "#242938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.5 206.25C170.992 206.25 206.25 170.992 206.25 127.5C206.25 84.0076 170.992 48.75 127.5 48.75C84.0076 48.75 48.75 84.0076 48.75 127.5C48.75 170.992 84.0076 206.25 127.5 206.25Z",
    fill: "#F47421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.5 165.694C148.594 165.694 165.694 148.594 165.694 127.5C165.694 106.406 148.594 89.3062 127.5 89.3062C106.406 89.3062 89.3062 106.406 89.3062 127.5C89.3062 148.594 106.406 165.694 127.5 165.694Z",
    stroke: "white",
    strokeWidth: 8.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9499 142.266C82.1048 142.266 88.7157 135.655 88.7157 127.5C88.7157 119.345 82.1048 112.734 73.9499 112.734C65.795 112.734 59.1841 119.345 59.1841 127.5C59.1841 135.655 65.795 142.266 73.9499 142.266Z",
    fill: "#F47421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 127.5H174.75H157.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 127.5H174.75",
    stroke: "#F47421",
    strokeWidth: 3.2378
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.95 138.013C79.7562 138.013 84.4631 133.306 84.4631 127.5C84.4631 121.694 79.7562 116.987 73.95 116.987C68.1439 116.987 63.437 121.694 63.437 127.5C63.437 133.306 68.1439 138.013 73.95 138.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.487 73.7415C137.41 80.8039 139.83 89.8345 146.892 93.9119C153.954 97.9894 162.985 95.5697 167.062 88.5073C171.14 81.4449 168.72 72.4143 161.658 68.3368C154.595 64.2594 145.565 66.6791 141.487 73.7415Z",
    fill: "#F47421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.625 153.264L103.875 168.42L112.625 153.264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.625 153.264L103.875 168.42",
    stroke: "#F47421",
    strokeWidth: 3.2378
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.17 75.8679C142.267 80.8962 143.99 87.3259 149.018 90.229C154.046 93.1321 160.476 91.4092 163.379 86.3809C166.282 81.3526 164.559 74.9229 159.531 72.0198C154.503 69.1168 148.073 70.8396 145.17 75.8679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.062 166.493C162.985 159.43 153.954 157.011 146.892 161.088C139.829 165.166 137.41 174.196 141.487 181.259C145.565 188.321 154.595 190.741 161.658 186.663C168.72 182.586 171.14 173.555 167.062 166.493Z",
    fill: "#F47421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.625 101.736L103.875 86.5804L112.625 101.736Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.625 101.736L103.875 86.5804",
    stroke: "#F47421",
    strokeWidth: 3.2378
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.379 168.619C160.476 163.591 154.047 161.868 149.018 164.771C143.99 167.674 142.267 174.104 145.17 179.132C148.073 184.161 154.503 185.883 159.531 182.98C164.56 180.077 166.282 173.648 163.379 168.619Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntuDark);
export default __webpack_public_path__ + "static/media/Ubuntu-Dark.db055f283785d52adb460323b4522992.svg";
export { ForwardRef as ReactComponent };